<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import SettingGuide from '../../SettingGuide.svelte';
	import { Button } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getEmeterDataRpcNamespace } from 'src/helpers/settings/emeter_settings_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';

	export let device: Device;

	let loading = false;
	const dataNamespace = getEmeterDataRpcNamespace(device);

	const resetCounters = async () => {
		loading = true;
		const res: SettingRequest = await gen2Request(device, `${dataNamespace}.ResetCounters`, {
			id: device.channel,
		});
		onSettingsResponse(res, device, {
			success: $format('toast_reset_energy_counters_success', {
				default: 'Energy totals were reset. History is unchanged.',
			}),
			danger: $format('error_global', { default: 'Something went wrong!' }),
		});
		loading = false;
	};
</script>

<SettingGuide
	text={$format('settings_guide_reset_energy_counters', {
		default: 'Zero the running energy totals. Recorded history stays on the device.',
	})}
/>

<Button {loading} width="full" size="m" id="button-reset-energy-counters" on:click={resetCounters}>
	{$format('button_reset_energy_counters', {
		default: 'Reset counters',
	})}
</Button>
